import React, { useContext } from "react";
import {
    ModalContainer,
    Content,
    IconContainer,
    TextContainer,
    Title,
    Description,
    Footer,
    CancelButton,
    DeleteButton,
    IconCircle,
} from "./DecommissionPrinterModal.styles";
import DeleteIcon from "../../../../../../images/gateways/delete.svg";
import { StyledModal } from "../../../Gateways.styles";
import { ApplicationContext } from "../../../../../../components/ApplicationProvider";
import Parser from "html-react-parser";

export type DecommissionPrinterModalProps = {
    open: boolean;
    printerName: string;
    isDecommissioning?: boolean;
    onCancel: () => void;
    onDecommission: () => void | Promise<void>;
};

const DecommissionPrinterModal: React.FC<DecommissionPrinterModalProps> = ({
    open,
    printerName,
    isDecommissioning = false,
    onCancel,
    onDecommission,
}) => {
    const { t } = useContext(ApplicationContext);
    return (
        <StyledModal
            open={open}
            onClose={onCancel}
            closeOnDimmerClick={false}
            data-testid="decommission-printer-modal"
        >
            <ModalContainer data-testid="decommission-printer-modal-container">
                <Content data-testid="decommission-printer-modal-content">
                    <IconContainer data-testid="decommission-printer-modal-icon-container">
                        <IconCircle data-testid="decommission-printer-modal-icon-circle">
                            <img
                                src={DeleteIcon}
                                alt="Decommission"
                                data-testid="decommission-printer-modal-icon"
                            />
                        </IconCircle>
                    </IconContainer>

                    <TextContainer data-testid="decommission-printer-modal-text-container">
                        <Title data-testid="decommission-printer-modal-title">
                            {t("devices.gateways.gateway_card.decommission_printer")}
                        </Title>
                        <Description data-testid="decommission-printer-modal-description">
                            {Parser(
                                t(
                                    "devices.gateways.gateway_card.decommission_printer_description",
                                    {
                                        printerName,
                                    }
                                )
                            )}
                        </Description>
                    </TextContainer>
                </Content>

                <Footer data-testid="decommission-printer-modal-footer">
                    <CancelButton
                        type="button"
                        onClick={onCancel}
                        disabled={isDecommissioning}
                        data-testid="decommission-printer-cancel-button"
                    >
                        {t("devices.cancel")}
                    </CancelButton>

                    <DeleteButton
                        type="button"
                        onClick={onDecommission}
                        disabled={isDecommissioning}
                        data-testid="decommission-printer-confirm-button"
                    >
                        {t("devices.gateways.gateway_card.decommission_printer")}
                    </DeleteButton>
                </Footer>
            </ModalContainer>
        </StyledModal>
    );
};

export default DecommissionPrinterModal;
